define(function (require, exports) {
    'use strict';

    function UserPrivileges() {
        return {
            hasPrivilege: function () {
                return true;
            }
        };
    }

    exports.userPrivileges = UserPrivileges;
});



// WEBPACK FOOTER //
// ./scripts/services/userPrivilegeService.js